import { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ Error Boundary caught:', error)
    console.error('Error Info:', errorInfo)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="page fade-in">
          <div className="card" style={{ marginTop: 40, marginLeft: 'auto', marginRight: 'auto', maxWidth: 600 }}>
            <div className="card-pad col g16" style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
              <div className="t-h2" style={{ color: 'var(--red)' }}>Something went wrong</div>
              <div className="t-body muted" style={{ marginTop: 8, lineHeight: 1.6 }}>
                {this.state.error?.message || 'An unexpected error occurred. We\'re sorry for the inconvenience. Please try refreshing the page or contact support if the problem persists.'}
              </div>

              {/* Error details (development only - collapsed by default) */}
              <details style={{ marginTop: 16, textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', fontSize: 12, color: 'var(--muted)', userSelect: 'none' }}>
                  📋 Error details (for debugging)
                </summary>
                <div style={{ marginTop: 8, padding: 12, background: 'var(--surface-3)', borderRadius: 'var(--r)', maxHeight: 200, overflowY: 'auto', fontSize: 11 }}>
                  <code className="mono" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {this.state.error?.stack || this.state.error?.toString()}
                  </code>
                </div>
              </details>

              <div className="row g10" style={{ marginTop: 20, justifyContent: 'center' }}>
                <button
                  className="btn btn-pri"
                  onClick={this.handleReset}
                  aria-label="Try again"
                >
                  Try Again
                </button>
                <button
                  className="btn btn-ghost"
                  onClick={this.handleReload}
                  aria-label="Reload page"
                >
                  Reload Page
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
